{
    "Device_Filter_SectionHeader": "Filtragem de tipo de dispositivo",
    "Device_Filter_Dropdown_Label": "Tipo de dispositivo",
    "NAME": "ReportsFilterDeviceFilter"
}